import api from './client'

/** تبدیل مسیر نسبی لوگو (users/logo/<id>/) به آدرس کامل API */
export const logoSrc = (path) => {
  if (!path) return ''
  if (path.startsWith('http')) return path
  const base = (api.defaults.baseURL || '').replace(/\/+$/, '')
  return base + (path.startsWith('/') ? path : '/' + path)
}

/** آپلود لوگو/عکس (دوربین موبایل یا فایل) — با extra می‌توان department_id یا user_id داد */
export async function uploadLogo(file, extra = {}) {
  const fd = new FormData()
  fd.append('logo', file)
  Object.keys(extra || {}).forEach((k) => fd.append(k, extra[k]))
  const res = await api.post('users/upload-logo/', fd)
  return res.data && res.data.logo
}
